export function getDefaultPlayer() {
    return {
        stats: {
            magicPower: new Decimal(0)
        },
        elements: {},
        currentCultivationElement: null,
        currentFormationElement: null
    };
}

export function getDefaultActions() {
    return {
        meditation: {
            isActive: false,
            progress: 0,
            duration: 0,
            baseDuration: 0,
            mpGain: new Decimal(0),
        },
        awakening: {
            isActive: false,
            progress: 0,
            duration: 1000,
            baseDuration: 1000,
            mpGain: 0,
            targetElement: null
        },
        cultivation: {}
    };
}

export function getDefaultUIInfo() {
    return {
        hasMoved: {
            hunting: true,
        },
        newElement: {
            formation: true,
            cultivation: true,
            spellbook: true,
        },
        currentCultivationMenu: "none",
        currentFormationMenu: "none",
        dustUpdate: true,
        starCreationAmount: 1,
        formationUpdate: true,
    };
}